import React from 'react';
import { Alert, Box, Button, Center, Loader, Paper, Stack, Text, Title, Group } from '@mantine/core';
import { IconAlertCircle, IconRefresh } from '@tabler/icons-react';

export function ErrorMessage({ message, onRetry }) {
  if (!message) return null;
  return <Alert color="red" icon={<IconAlertCircle size={18} />} title="İşlem gerçekleştirilemedi">
    <Group justify="space-between" align="center" gap="xs"><Text size="sm">{message}</Text>
      {onRetry && <Button variant="subtle" size="xs" leftSection={<IconRefresh size={14} />} onClick={onRetry}>Tekrar dene</Button>}
    </Group>
  </Alert>;
}
export function Loading() { return <Center mih={180}><Loader color="blue" /></Center>; }
export function Empty({ title='Henüz kayıt yok', description, children }) {
  return <Paper withBorder radius="lg" p="xl"><Stack align="center" gap="xs" py="lg">
    <Title order={4}>{title}</Title><Text c="dimmed" ta="center" size="sm">{description || 'Filtrelerinizi değiştirin veya yeni kayıt oluşturun.'}</Text>{children}
  </Stack></Paper>;
}
export function DetailField({ label, children }) {
  return <Box><Text size="xs" c="dimmed" mb={3}>{label}</Text><Text size="sm" fw={500}>{children ?? '—'}</Text></Box>;
}
export function PageHead({ eyebrow, title, description, action }) {
  return <Group justify="space-between" align="start" gap="md" mb="lg">
    <Box><Text size="xs" fw={700} c="blue" tt="uppercase" style={{letterSpacing: '.07em'}}>{eyebrow}</Text>
      <Title order={2} mt={4} className="re-page-title">{title}</Title>
      {description && <Text size="sm" c="dimmed" mt={4}>{description}</Text>}</Box>{action}
  </Group>;
}
